export default "__VITE_ASSET__16cadc83__"